export const makeHumanReadableTime = (
  time: number | undefined | null,
): string => {
  if (!time) return "";

  const roundedTime = Math.round(time);
  const hours = Math.floor(roundedTime / 3600);
  const minutes = Math.floor((roundedTime % 3600) / 60);
  const seconds = roundedTime % 60;

  return `${hours ? `${hours}h ` : ""}${minutes ? `${minutes}m ` : ""}${seconds ? `${seconds}s` : ""}`;
};
